export default __webpack_public_path__ + "static/media/gallery-wip-clamp-card_00.7393dc3a.jpg";